import { IAddress } from "../contractors/IAddress";
import { IAppointment } from "./appointments/IAppointment";
import { ICustomer } from "./ICustomer";
import { IStatusReason } from "./IStatusReason";

export enum JobsheetStatus {
    Cancelled = -100,
    PendingCancellation = -50,
    OnQuery = -1,
    Pending = 0,
    PreCompletion = 70,
    EngineerToClear = 80,
    NacPending = 90,
    Completed = 100
}

export interface IJobsheet {
    id: string,
    works_type: number,
    booking_source: string,
    version: string,
    created: string,
    created_by: string,
    discipline_id: string,
    status: JobsheetStatus,
    status_reason_id: string | null,
    status_sub_reason_id: string | null,
    status_last_updated: string,
    status_last_updated_by: string,
    status_reason?: IStatusReason | null,
    completed_date: string | null,
    completed_by_id: string | null,
    is_verified: boolean,
    customer_id: string,
    customer: ICustomer | null,
    premise_type: number,
    site_id: string | null,
    address: IAddress,
    value_vat_code: string,
    value_materials_nett: number,
    value_labour_nett: number,
    value_nett: number,
    value_vat: number,
    value_gross: number,
    value_estimated_nett: number,
    value_estimated_vat: number,
    value_estimated_gross: number,
    value_paid: number,
    value_discount_requested: number,
    value_discount_is_percentage: boolean,
    value_discount_applied: number,
    value_discount_offer_id: string | null,
    value_deposit_expected: number | null,
    value_method: number,
    value_autocalc: boolean,
    appointment_id: string | null,
    appointment_last_id: string,
    appointment: IAppointment | null,
    awaiting_acceptance: boolean,
    is_invoice_requested: boolean,
    is_dual_visit: boolean,
    tax_date: string | null,
    contact_caller_id: string,
    contact_billpayer_id: string,
    contact_site_id: string,
    assigned_agent_id: string | null,
    order_number: string | null,
    works_report_id: string,
    quote_expiration_date: string
}